import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService, DanhMucService, SuKienCongToService, DatetimeService } from '../../../services/index';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationService } from 'primeng/api';
@Component({
  selector: 'app-popchitietsukiencongto',
  templateUrl: './popchitietsukiencongto.component.html',
  styleUrls: ['./popchitietsukiencongto.component.scss']
})
export class PopchitietsukiencongtoComponent implements OnInit {

  @Input() meterid: number;
  lstSuKien = [];
  lstTypeSuKien = [];
  type_sukien = "ALL";
  lst_detail_skct = [];
  isProgress: number = 0;
  isProgress_chitiet: number = 0;
  //Biến quản lý thông báo
  msgs_thongkeskct = [];
  msgs_chitietp = []
  //Biến quản lý thời gian
  paraQueryTuNgay: Date;
  tungay: string = null;
  paraQueryDenNgay: Date;
  denngay: string;
  maxDate: Date;
  maxDate1: Date;
  minDate: Date;
  kieu: string = "";
  //Biến quản lý trang
  totalRows_chitietskct: number = null;
  soDong_chitietskct: number = 20;
  currentPage_chitietskct: number;
  totalPage_chitietskct: number;
  subscription: Subscription;
  //Cây thư mục
  tenDanhmuc: string = "";
  danhmucid: any = 0;
  loaiDanhmuc: any;

  constructor(
    private danhMucService: DanhMucService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private sukiencongto: SuKienCongToService,
    private userService: UserService,
    private dateService: DatetimeService
  ) { }

  ngOnInit() {
    this.isProgress = 1;
    this.paraQueryTuNgay = this.paraQueryDenNgay = new Date();
    this.maxDate = this.maxDate1 = new Date();
    this.minDate = new Date(this.paraQueryTuNgay);
    // this.subscription = this.danhMucService.navItem$.subscribe(
    //   item => {
    //     this.CaythumucSelected(item);
    //   })
    this.get_type_sk();
  }

  get_type_sk() {

    this.sukiencongto.get_Type_SuKien().subscribe(res => {
      let data = (res).data;
      this.lstTypeSuKien = data;
    });
  }
  public CaythumucSelected(item): void {
    this.tenDanhmuc = item.label;
    this.danhmucid = item.value;
    this.loaiDanhmuc = item.type;
    // if (this.danhmucid >= 0) {
    //   this.get_all_sukien(this.danhmucid);
    // }
  }
  get_Detail_skct(sotrang) {
    if (this.checkdate() == 1) {
      this.totalRows_chitietskct = 0;
      this.lst_detail_skct = [];
      return;
    }
    if (this.checkdate() == 2) {
      this.totalRows_chitietskct = 0;
      this.lst_detail_skct = [];
      return;
    }
    this.isProgress_chitiet = 1;
    let user = this.userService.getCurrentUser().mataikhoan;
    this.sukiencongto.get_ALL_Detail_SuKien_By_MetterID(
      this.meterid,
      user,
      0,
      this.type_sukien,
      this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay),
      sotrang,
      this.soDong_chitietskct
    ).subscribe(res => {


      this.lst_detail_skct = (res).data;
      if (this.lst_detail_skct.length == 0) {
        this.msgs_chitietp = [];
        this.tungay = null;
        this.denngay = null;
        this.kieu = "";
        this.isProgress_chitiet = 0;
        this.totalRows_chitietskct = 0;
        //this.msgs_chitietp.push({ severity: 'error', summary: 'Thông báo', detail: 'Không tìm thấy thông tin nào.' });
        return 1;
      }
      this.msgs_chitietp = [];
      this.isProgress_chitiet = 0;
      this.tungay = this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay);
      this.denngay = this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay);
      this.kieu = this.type_sukien;
      this.totalPage_chitietskct = this.lst_detail_skct[0].totalpage;
      this.currentPage_chitietskct = this.lst_detail_skct[0].pagenum;
      this.totalRows_chitietskct = this.lst_detail_skct[0].rowscount;
    });
  }
  checkdate() {
    if (this.dateService.compareTwoDate(this.paraQueryDenNgay, this.paraQueryTuNgay) == -1) {
      this.msgs_chitietp = [];
      this.totalRows_chitietskct = 0;
      this.totalPage_chitietskct = 0;
      this.currentPage_chitietskct = 0;
      this.soDong_chitietskct = 20;
      this.msgs_chitietp.push({ severity: 'error', summary: 'Thông báo', detail: 'Đến ngày không được nhỏ hơn từ ngày' });
      return 1;
    }
    if (this.dateService.calculateTwoDate(this.paraQueryDenNgay, this.paraQueryTuNgay) > 31) {
      this.msgs_chitietp = [];
      this.totalRows_chitietskct = 0;
      this.totalPage_chitietskct = 0;
      this.currentPage_chitietskct = 0;
      this.soDong_chitietskct = 20;
      this.msgs_chitietp.push({ severity: 'error', summary: 'Thông báo', detail: 'Chỉ truy xuất tối đa trong khoảng 31 ngày' });
      return 2;
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/canhbao/popchitietsukiencongto/popchitietsukiencongto.component.ts